






































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  i18n: {
    messages: {
      en: {
        of: "of",
      },
      nb: {
        of: "of",
      },
    },
  },
})
export default class SImageCarousel extends Vue {
  @Prop({ type: Array, required: true }) private imageUrls!: string[];

  private currentImage = 0;

  @Watch('imageUrls', { deep: true})
  private handleImageRemoval() {
    this.currentImage = 0;
  }

  private changeImage(increment: number) {
    this.currentImage = (this.currentImage + increment + this.imageUrls.length) % this.imageUrls.length;
  }
}

